var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7 0C3.14 0 0 3.14 0 7C0 10.86 3.14 14 7 14C10.86 14 14 10.86 14 7C14 3.14 10.86 0 7 0ZM7 12C4.24 12 2 9.76 2 7C2 4.24 4.24 2 7 2C9.76 2 12 4.24 12 7C12 9.76 9.76 12 7 12ZM10 7C10 7.55 9.55 8 9 8H8V9C8 9.55 7.55 10 7 10C6.45 10 6 9.55 6 9V8H5C4.45 8 4 7.55 4 7C4 6.45 4.45 6 5 6H6V5C6 4.45 6.45 4 7 4C7.55 4 8 4.45 8 5V6H9C9.55 6 10 6.45 10 7Z",
  fill: "#0A893D"
})));
export { SvgAdd as ReactComponent };
export default __webpack_public_path__ + "assets/icons/add.dab069.svg";